import Alpine from 'alpinejs'
import '../controllers'

window.Alpine = Alpine
Alpine.start()
